export const labelClassNames = ["atlas-text-xs", "atlas-leading-3"];
export const sectionTitleClass = [
  "atlas-font-semibold",
  "atlas-text-sm",
  "atlas-leading-5",
  "atlas-mb-4",
];
